import {
	type ColumnOrderState,
	type RowData,
	type Table,
	type TableFeature,
	type Updater,
} from '@tanstack/react-table';

import { type ColumnReorderContext } from '../charlie-table.types';

export const ColumnOrderWithContextFeature: TableFeature = {
	createTable: <TData extends RowData>(table: Table<TData>): void => {
		table.setColumnOrderWithContext = (
			updater: Updater<ColumnOrderState>,
			context?: ColumnReorderContext,
		) => {
			table.options.onColumnOrderChange?.(updater, context);
		};
	},
};
